export default __webpack_public_path__ + "static/media/logo.86477e19.svg";